import React, { useState } from 'react';
import { Check, Star, XIcon } from 'lucide-react';
import { WebinarMCStickyBar } from '../components/WebinarMCStickyBar';
export function WebinarMCSearchPuppyPage() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-5903" data-mp="3mbgirqhzvt2b">
      {/* Registration Popup */}
      {isPopupOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" onClick={() => setIsPopupOpen(false)} data-id="element-5904" data-mp="2tlzy5f0m9ggn">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm relative" onClick={e => e.stopPropagation()} data-id="element-5905" data-mp="2ylmc5qo9r0qi">
            <button onClick={() => setIsPopupOpen(false)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600" data-id="element-5906" data-mp="37dxyb0cco20o">
              <XIcon className="w-6 h-6" data-id="element-5907" data-mp="2atp9ap2srj1j" />
            </button>
            <div className="flex justify-center items-center w-full pt-4" data-id="element-5908" data-mp="2evsl5etdopnc">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-gsearch_cmp-mcc_pt-optin-puppy" height="500" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
            border: 'none',
            borderRadius: '15px',
            backgroundColor: 'white',
            maxWidth: '100%'
          }} data-id="element-5909" data-mp="1j89w9m442n0j"></iframe>
            </div>
            <p className="text-xs text-gray-500 text-center mt-3" data-id="element-5910" data-mp="vhmor1y3xzei">
              We HATEN spam. Je e-mailadres is 100% veilig
            </p>
            <div className="flex items-center gap-3 mt-3 px-2" data-id="element-5911" data-mp="lk86cwsmj0jk">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee Buijs" className="w-9 h-9 rounded-full object-cover flex-shrink-0" data-id="element-5912" data-mp="llt22pqocpj0" />
              <p className="text-xs text-gray-600 leading-snug" data-id="element-5913" data-mp="e8bpqchloa8f">
                Dit webinar wordt gegeven door Amee Buijs, honden
                gedragsdeskundige met 10 jaar ervaring.
              </p>
            </div>
          </div>
        </div>}

      {/* Navigation */}
      <nav className="w-full border-b border-gray-200 py-4 px-6 bg-white" data-id="element-5914" data-mp="997d1bvgvudc">
        <div className="flex justify-center md:justify-between items-center" data-id="element-5915" data-mp="wzur6evz7g8c">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-5916" data-mp="wxqpm3ljutb8" />
          <div className="hidden md:block" data-id="element-5917" data-mp="rzp6jio4itzr">
            <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="500px" data-theme="light" data-id="element-5918" data-mp="rynkkj5kkn39">
              <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-5919" data-mp="1pu9kk3w0vin6">
                Trustpilot
              </a>
            </div>
          </div>
        </div>
        <div className="md:hidden flex justify-center mt-3 w-full" data-id="element-5920" data-mp="1zqco9e6ivpc8">
          <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-token="d24193a8-3943-4d9c-bcbd-f0b97f9d6fb9" data-id="element-5921" data-mp="1c34jcxd0aiaq">
            <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener" data-id="element-5922" data-mp="sedphb6175vx">
              Trustpilot
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-20 grid md:grid-cols-12 gap-12 items-center" data-id="element-5923" data-mp="1106jxmv7i318">
        <div className="md:col-span-7" data-id="element-5924" data-mp="15yzx1e6kzs0v">
          <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-4" data-id="element-5925" data-mp="1b05prc08rfae">
            Gratis Online Webinar: Je Puppy of Hond Opvoeden
          </p>
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#1a2b4a] mb-6 leading-tight" data-id="element-5926" data-mp="1fsytpxnvyjlf">
            Zo voed je je puppy of hond op zonder straffen of corrigeren
          </h1>
          <button onClick={() => setIsPopupOpen(true)} className="md:hidden mx-auto block bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md mb-4" data-id="element-5927" data-mp="1otx0uotmf788">
            Inschrijven webinar
          </button>
          <div className="md:hidden flex items-center justify-center gap-4 mb-8" data-id="element-5928" data-mp="3vkeey4iijcum">
            <div className="flex -space-x-3" data-id="element-5929" data-mp="4cimgrmhj99n">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5930" data-mp="3sxltb4danqi4" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5931" data-mp="3j8kbd8n6uz1i" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5932" data-mp="asil3as16ydh" />
            </div>
            <div data-id="element-5933" data-mp="w5p2690k8fk">
              <p className="font-bold text-lg text-[#1a2b4a]" data-id="element-5934" data-mp="2qjdhimyoixml">97.283+</p>
              <p className="text-xs text-gray-600" data-id="element-5935" data-mp="2qkog88d9pf6u">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-5936" data-mp="1dkbhnxozpt2o">
            Ontdek in dit gratis 90-minuten webinar de eenvoudige, liefdevolle
            methode die duizenden hondenbaasjes nu gebruiken om hun puppy of
            volwassen hond op te voeden - zonder commando's, dwang of
            correcties.
          </p>

          <ul className="space-y-4 mb-8" data-id="element-5937" data-mp="18k7167o30ycg">
            {['Waarom de meeste opvoedingstips niet werken - en welke aanpak je puppy of hond wél begrijpt', 'De taal van je hond leren lezen - zodat je weet wat hij voelt, wil en nodig heeft', 'Hoe je vanaf dag 1 een sterke band opbouwt met je puppy (of die band herstelt met je volwassen hond)', 'Waarom "ongehoorzaamheid" eigenlijk niet bestaat - en hoe je zorgt dat je hond doet wat je vraagt zonder ooit te corrigeren', 'De 3 kernbehoeften van elke puppy en hond - en hoe je daar dagelijks op inspeelt', "Een rustige, blije, goed opgevoede hond - door communicatie in plaats van commando's of straf"].map((item, i) => <li key={i} className="flex items-start" data-id="element-5938" data-mp="3ofvehgx92gz2" data-mpi={i}>
                <Check className="w-6 h-6 text-blue-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-5939" data-mp="3ohg8n5fnjxwe" />
                <span className="text-gray-700 font-medium" data-id="element-5940" data-mp="6as69nbzlouf">{item}</span>
              </li>)}
          </ul>

          <div className="hidden md:flex items-center gap-4" data-id="element-5941" data-mp="1cqjosfcr7e7">
            <div className="flex -space-x-3" data-id="element-5942" data-mp="f8lyon6mrycb">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5943" data-mp="b8tne2pure39" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5944" data-mp="k1f4ledu5cpz" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5945" data-mp="3asd9ljxk3xnb" />
            </div>
            <div data-id="element-5946" data-mp="3ko7xatgn0iwy">
              <p className="font-bold text-xl text-[#1a2b4a]" data-id="element-5947" data-mp="3ppdrkvpy4e8l">97.283+</p>
              <p className="text-sm text-gray-600" data-id="element-5948" data-mp="3pom5qcm5huvi">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
        </div>

        <div className="md:col-span-5 flex justify-center" data-id="element-5949" data-mp="2wzwzjz68mzcw">
          <div className="p-6 rounded-3xl w-full max-w-sm mx-auto" data-id="element-5950" data-mp="31zt7g9i23axq">
            <div className="flex justify-center items-center w-full" data-id="element-5951" data-mp="31yi42asiw575">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-gsearch_cmp-mcc_pt-optin-puppy" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white',
              maxWidth: '100%'
            }} data-id="element-5952" data-mp="36rkzkogv1opz"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Steps Section */}
      <section className="bg-gray-50 py-20" data-id="element-5953" data-mp="he9tp0t5fqrk">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-5954" data-mp="hhfj6h5owunt">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16" data-id="element-5955" data-mp="ch1m1u5mn54k">
            Je puppy of hond opvoeden in drie stappen
          </h2>

          <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-5956" data-mp="3ny00xgx1jyb">
            <div className="flex flex-col items-center" data-id="element-5957" data-mp="3og42g9tl2gs">
              <img src="https://cdn.magicpatterns.com/uploads/7G3FddFkmDX1PP48Js3VUV/agenda_icon_(1).png" alt="Agenda icoon" className="w-32 h-32 object-contain mb-6" data-id="element-5958" data-mp="3uurbcu5fazgk" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5959" data-mp="3kxcu4sboe6n7">Stap 1.</h3>
              <p className="text-gray-600" data-id="element-5960" data-mp="c8w7b6a6qe7n">
                Vul het formulier in en reserveer jouw plekje
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-5961" data-mp="7acmxab8pahe">
              <img src="https://cdn.magicpatterns.com/uploads/oxDbACMiW4Zh5cMbL7Ry7C/cursor_webinar_v3_(1).png" alt="Webinar knop icoon" className="w-32 h-32 object-contain mb-6" data-id="element-5962" data-mp="l29ad11yqw7g" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5963" data-mp="3pibsaq0j0n9f">Stap 2.</h3>
              <p className="text-gray-600" data-id="element-5964" data-mp="3kipfghom1915">
                Klik tegen die tijd op de link in je e-mail om direct deel te
                nemen
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-5965" data-mp="3tgrnhh6rh1xx">
              <img src="https://cdn.magicpatterns.com/uploads/swcfYXFhsSevmDxKpdEyU7/vrouw_hond_knuffel_(1).png" alt="Vrouw knuffelt hond" className="w-32 h-32 object-contain mb-6" data-id="element-5966" data-mp="1dqomnftpn0f3" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5967" data-mp="1h7jb8jezlpa8">Stap 3.</h3>
              <p className="text-gray-600" data-id="element-5968" data-mp="1lapinudu5mia">
                Leer in 90 minuten hoe je je puppy of hond liefdevol opvoedt -
                zonder straffen of corrigeren
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-5969" data-mp="1cako4ktqqilj">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* Social Proof / Testimonials */}
      <section className="py-20 bg-[#fbfaf8]" data-id="element-5970" data-mp="1q76g5f6xdd81">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-5971" data-mp="1v7lr603qi8mu">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16 max-w-3xl mx-auto leading-tight" data-id="element-5972" data-mp="1v610ilkjj9u9">
            Duizenden baasjes voeden hun hond inmiddels zo op - en zeggen
            allemaal hetzelfde: <br data-id="element-5973" data-mp="2xkn41sc03ar7" />
            <span className="italic" data-id="element-5974" data-mp="2xl6njdhau77c">
              "Eindelijk een aanpak die werkt zonder straffen."
            </span>
          </h2>

          {/* Videos */}
          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-5975" data-mp="2sjha5r6lthg3">
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5976" data-mp="2nlfqb41cte3k">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5977" data-mp="2jlf590jr24nj">
                <iframe src="https://player.vimeo.com/video/1086787571?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 2" data-id="element-5978" data-mp="2enm08au6ngou"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5979" data-mp="6gijyigbxcqy">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5980" data-mp="bbfq9hm85805">
                <iframe src="https://player.vimeo.com/video/1086787549?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 3" data-id="element-5981" data-mp="kcvybipkgy17"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5982" data-mp="3534m4mxxzxvs">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5983" data-mp="1bkxjd74wzz5w">
                <iframe src="https://player.vimeo.com/video/1086787601?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 1" data-id="element-5984" data-mp="16kj87g80o93n"></iframe>
              </div>
            </div>
          </div>

          {/* Review Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-16 text-left" data-id="element-5985" data-mp="8zn6m3xc3khc">
            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5986" data-mp="4xa3zodvw2os">
              <div className="flex items-center mb-4" data-id="element-5987" data-mp="3qyg19muu63nk">
                <div className="flex text-green-500 mr-2" data-id="element-5988" data-mp="3qyznvgvflg7x">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5989" data-mp="3uz9qcjk0loi1" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5990" data-mp="3h6k3ye0kqhke">8 jul 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5991" data-mp="3m5wnopw5f8ir">
                Hele fijne cursus. Aanrader zelfs voor de ervaren honden
                liefhebber.
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5992" data-mp="3cb4t7uxv51s7">
                Nu hebben wij altijd herplaatsers, dus we zijn wel wat gewend.
                Maar bij onze laatste herplaatser hebben we wel hulp nodig. In
                kort tijd nu al zoveel geleerd en handvaten gekregen. Ben enorm
                enthousiast over deze cursus en ik kreeg ook veel hulp
                aangeboden. Het is netjes overzichtelijk, duidelijk maar wat met
                het meeste aanspreekt is dat het zonder commando's gaat maar via
                communiceren.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5993" data-mp="v079fri2rtl6">
                - Nicolette
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5994" data-mp="q49r5fn94d5r">
              <div className="flex items-center mb-4" data-id="element-5995" data-mp="l4x4auwdr636">
                <div className="flex text-green-500 mr-2" data-id="element-5996" data-mp="1ir47q1gy6sdy">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5997" data-mp="1dssx3oitwduo" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5998" data-mp="18zqdo97rmks7">3 sep 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5999" data-mp="140x1ck47sztm">
                Niet goed maar uitstekend!
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-6000" data-mp="21ix3u4rbctpw">
                Amée is een zeer lieve vrouw met een hart voor honden en dat
                merk je zeer goed. De tips helpen echt. Ik raad iedereen met
                puppy's, jongere hondjes en alle andere leeftijden deze cursus
                aan, vooral mensen die problemen hebben met hun troetel. Zowel
                gedragsproblemen als medische problemen. Volg even de gratis
                Masterclass en je bent volledig overtuigd van de cursus en de
                mensen erachter. Heel veel liefs aan iedereen van het team.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-6001" data-mp="2mys2wlpj7aya">
                - Tine Oetzmann
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-6002" data-mp="2wq62suleacry">
              <div className="flex items-center mb-4" data-id="element-6003" data-mp="31q27yx5twa93">
                <div className="flex text-green-500 mr-2" data-id="element-6004" data-mp="31rljybkgbz52">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-6005" data-mp="36msk59eiilp8" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-6006" data-mp="3w15na8g2aeo7">20 apr 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-6007" data-mp="3rzkcqtr02ch6">
                Dit was de eerste keer dat ik een online hondencursus volgde...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-6008" data-mp="9tfffrrvyxbt">
                Dit was de eerste keer dat ik een online hondencursus volgde en
                ik heb er veel van opgestoken. Hoewel mijn honden zich (meestal)
                prima gedragen, wilde ik vooral leren wat ik zelf nog een beter
                kan doen ivm de communicatie. Dat is gelukt, het valt echt op
                dat omdat ik mij zelf anders opstel, mijn honden nu veel
                rustiger communiceren met andere honden. Vooral met onbekende
                honden was er toch vaak wel flink geblaf. Nu bijna niet meer,
                heerlijk, wat is wandelen toch/weer een genot. Idd: stressless!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-6009" data-mp="2pktkfu2ao8ma">
                - Margreet
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-6010" data-mp="19thj55hfropy">
              <div className="flex items-center mb-4" data-id="element-6011" data-mp="w2cqwogedypn">
                <div className="flex text-green-500 mr-2" data-id="element-6012" data-mp="w3nx0uxbfijx">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-6013" data-mp="1047q9nerq20s" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-6014" data-mp="1nrfvk5c75b2t">13 aug 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-6015" data-mp="1sru3zohpmn1d">
                Ik vond het prettig mijn ervaring op te halen...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-6016" data-mp="1jrfhwmwx93wt">
                Ik vond het prettig mijn ervaring op te halen en voorbereid te
                zijn op de puppy die ik al snel krijg. Goed gewerkt!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-6017" data-mp="8djpich0aynn">
                - Henne Buskermolen
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-6018" data-mp="nkz2rtksrwao">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* About Amee */}
      <section className="py-20 bg-white" data-id="element-6019" data-mp="3w0siw7b7v5r7">
        <div className="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center" data-id="element-6020" data-mp="3vyzd0u8fgpk9">
          <div data-id="element-6021" data-mp="4npiybbk8gsw">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-6022" data-mp="4o7oxzo0y9e0">
              Hoi, ik ben Amee en ik geef dit webinar.
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-6023" data-mp="3r2r43yktpslj">
              <p data-id="element-6024" data-mp="3d1ohnkpx2ga3">
                Ik ben Amee de Bruijn, hondengedragsdeskundige en oprichter van
                StresslessDogs.nl. En ik weet hoe het voelt als je net een puppy
                in huis hebt - of een volwassen hond die nog van alles moet
                leren - en je geen idee hebt waar je moet beginnen.
              </p>
              <p data-id="element-6025" data-mp="2ti91atc1d3h8">
                In de afgelopen jaren heb ik meer dan 15.000 baasjes geholpen om
                hun puppy of hond op te voeden. Niet door te 'trainen' met
                commando's, beloningen of correcties, maar door iets dat veel
                fundamenteler is: communicatie. Want zodra je je hond begrijpt,
                hoef je hem nooit meer te corrigeren.
              </p>
              <p data-id="element-6026" data-mp="3cf0jezfudcjp">
                Wat ik in al die jaren heb gezien, is dat de meeste
                opvoedingsproblemen niet ontstaan door een 'eigenwijze' puppy of
                een 'ongehoorzame' hond. Ze ontstaan doordat baasjes en honden
                letterlijk twee verschillende talen spreken. Zodra je die taal
                leert, hoef je niet meer te straffen of corrigeren. De strijd
                verdwijnt. En je hond doet ineens wat je vraagt - omdat hij het
                wíl, niet omdat hij het moet.
              </p>
              <p data-id="element-6027" data-mp="2wtfp4mblkn0t">
                Daarom werk ik uitsluitend met methodes die gebaseerd zijn op
                vertrouwen, veiligheid, wederzijds respect en echte
                communicatie. Geen dwang, geen pijn, geen angst, geen straf.
                Alleen liefde en begrip - dat is hoe je een puppy of hond écht
                goed opvoedt.
              </p>
              <p data-id="element-6028" data-mp="3bl6c5vdwesng">
                Dit webinar is mijn manier om dit met zoveel mogelijk
                hondenbaasjes te delen. Omdat ik geloof dat elke puppy, elke
                hond en elke mens de kans verdient op een liefdevolle,
                stressvrije opvoeding.
              </p>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-6029" data-mp="1q5qx18zk3qpq">
            <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee met Sophietje" className="w-full h-auto object-cover" data-id="element-6030" data-mp="1q7ljirqh7qvx" />
          </div>
        </div>
      </section>

      {/* Bottom Registration */}
      <section className="py-20 bg-gray-50" data-id="element-6031" data-mp="1dv9d2gdzi0lx">
        <div className="max-w-md mx-auto px-4" data-id="element-6032" data-mp="1dw173mrxnqa3">
          <div className="p-6 rounded-3xl w-full" data-id="element-6033" data-mp="18w6hrnnt38r5">
            <div className="flex justify-center items-center" data-id="element-6034" data-mp="18xhhnce4rwcz">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-gsearch_cmp-mcc_pt-optin-puppy" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white'
            }} data-id="element-6035" data-mp="26kgk63ri7yis"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-12" data-id="element-6036" data-mp="h3p9ywbirj5h">
        <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-6037" data-mp="250nccy92jy5z">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-12 object-contain mb-6" data-id="element-6038" data-mp="29sokc7z7f2q7" />
          <p className="font-semibold text-[#1a2b4a] mb-2" data-id="element-6039" data-mp="202v7z4r8mjkw">
            Voor liefdevolle hondenbaasjes
          </p>
          <a href="mailto:amee@stresslessdogs.nl" className="text-blue-600 hover:underline mb-8" data-id="element-6040" data-mp="2nqd6rk8x6hxd">
            amee@stresslessdogs.nl
          </a>

          <div className="text-xs text-gray-500 max-w-3xl leading-relaxed" data-id="element-6041" data-mp="2er8akkktz0od">
            <p className="mb-2" data-id="element-6042" data-mp="2irs31auglg46">
              © 2025 Stressless Dogs. Alle rechten voorbehouden.
            </p>
            <p data-id="element-6043" data-mp="13arrmha2i1wr">
              Deze website maakt gebruik van cookies en vergelijkbare
              technologieën voor analytische en advertentiedoeleinden. Deze
              pagina is een advertorial voor Stressless Dogs. Stressless Dogs is
              een onafhankelijk bedrijf en is op geen enkele wijze verbonden aan
              of onderdeel van Meta (voorheen Facebook). Deze advertentie wordt
              getoond via het Meta advertentieplatform, maar Meta is niet
              verantwoordelijk voor de inhoud of diensten aangeboden door
              Stressless Dogs.
            </p>
          </div>
        </div>
      </footer>
      <WebinarMCStickyBar onClickCTA={() => setIsPopupOpen(true)} data-id="element-6044" data-mp="c52vjpywabem" />
    </div>;
}